import { Button } from "@/components/ui/button";
import { SlidersHorizontal, GripVertical } from "lucide-react";

/**
 * ColumnToolbar — Renders the "Customize Columns" and "Rearrange Columns" buttons.
 * Used alongside useColumnManager and ColumnModals.
 *
 * @param {object} columnManager - Return value from useColumnManager()
 * @param {string} className - Optional additional CSS classes
 */
export function ColumnToolbar({ columnManager, className = "" }) {
  const { openCustomize, openRearrange } = columnManager;

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Button
        variant="outline"
        size="sm"
        className="rounded-sm h-8 text-xs gap-1.5"
        data-testid="customize-columns-btn"
        onClick={openCustomize}
      >
        <SlidersHorizontal className="w-3.5 h-3.5" strokeWidth={1.5} />
        Customize Columns
      </Button>
      <Button
        variant="outline"
        size="sm"
        className="rounded-sm h-8 text-xs gap-1.5"
        data-testid="rearrange-columns-btn"
        onClick={() => openRearrange()}
      >
        <GripVertical className="w-3.5 h-3.5" strokeWidth={1.5} />
        Rearrange Columns
      </Button>
    </div>
  );
}
